import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 shadow-md' : 'bg-white/80'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/10d1ee7f672303b24e915f86db5d57f1/37a2e6272bbcc62cce0a8e4dd27729ba.png" 
              alt="グルメスワイプ" 
              className="h-10 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('benefits')}
              className="text-sm text-gray-600 hover:text-black transition-colors cursor-pointer"
            >
              特徴
            </button>
            <button
              onClick={() => scrollToSection('benefits')}
              className="text-sm text-gray-600 hover:text-black transition-colors cursor-pointer"
            >
              参加メリット
            </button>
            <button
              onClick={() => scrollToSection('flow')}
              className="text-sm text-gray-600 hover:text-black transition-colors cursor-pointer"
            >
              参加の流れ
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-sm text-gray-600 hover:text-black transition-colors cursor-pointer"
            >
              FAQ
            </button>
          </nav>

          {/* Desktop CTA Button */}
          <a
            href="https://lin.ee/PJ9odjt"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:block bg-[#EDD92A] text-black font-bold px-6 py-3 rounded-xl hover:shadow-lg transition-all duration-300 hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
            style={{ boxShadow: '0 4px 12px rgba(237,217,42,0.3)' }}
          >
            LINEで先行テスター/投稿者登録（無料）
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-black p-2 cursor-pointer"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('benefits')}
                className="text-sm text-gray-600 hover:text-black transition-colors text-left cursor-pointer"
              >
                特徴
              </button>
              <button
                onClick={() => scrollToSection('benefits')}
                className="text-sm text-gray-600 hover:text-black transition-colors text-left cursor-pointer"
              >
                参加メリット
              </button>
              <button
                onClick={() => scrollToSection('flow')}
                className="text-sm text-gray-600 hover:text-black transition-colors text-left cursor-pointer"
              >
                参加の流れ
              </button>
              <button
                onClick={() => scrollToSection('faq')}
                className="text-sm text-gray-600 hover:text-black transition-colors text-left cursor-pointer"
              >
                FAQ
              </button>
              <a
                href="https://lin.ee/PJ9odjt"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#EDD92A] text-black font-bold px-6 py-3 rounded-xl text-center whitespace-nowrap cursor-pointer"
              >
                LINEで先行テスター/投稿者登録（無料）
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
